import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "../auth/_guards/auth.guard";

const routes: Routes = [
    {
        "path": "",
        "component": ThemeComponent,
        // "canActivate": [AuthGuard],
        "children": [
            {
                "path": "analytics/:id",
                "loadChildren": ".\/pages\/aside-left-display-disabled\/analytics\/analytics.module#AnalyticsModule"
            },
	    {
                "path": "impressions/:id",
                "loadChildren": ".\/pages\/aside-left-display-disabled\/impressions\/impressions.module#ImpressionsModule"
            },
	    {
                "path": "content/:id",
                "loadChildren": ".\/pages\/aside-left-display-disabled\/content\/content.module#ContentModule"
            },
	    {
                "path": "discovery/:id",
                "loadChildren": ".\/pages\/aside-left-display-disabled\/discovery\/discovery.module#DiscoveryModule"
            },
            {
                "path": "crawl/:id",
                "loadChildren": ".\/pages\/aside-left-display-disabled\/crawl\/crawl.module#CrawlModule"
            },
            {
                "path": "404",
                "loadChildren": ".\/pages\/default\/not-found\/not-found\/not-found.module#NotFoundModule"
            },
            {
                "path": "",
                "redirectTo": "analytics",
                "pathMatch": "full"
            }
        ]
    },
    {
        "path": "**",
        "redirectTo": "404",
        "pathMatch": "full"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ThemeRoutingModule { }



// WEBPACK FOOTER //
// /home/node/src/app/theme/theme-routing.module.ts